var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8099_22736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.84 31.92L64.12 13.2C63.36 12.44 62.32 12 61.28 12H34.72C33.68 12 32.64 12.44 31.92 13.16L13.16 31.92C12.44 32.64 12 33.68 12 34.72V61.24C12 62.32 12.44 63.32 13.16 64.08L31.88 82.8C32.64 83.56 33.68 84 34.72 84H61.24C62.32 84 63.32 83.56 64.08 82.84L82.8 64.12C83.56 63.36 83.96 62.36 83.96 61.28V34.72C84 33.68 83.56 32.64 82.84 31.92ZM76 59.6L59.6 76H36.4L20 59.6V36.4L36.4 20H59.6L76 36.4V59.6Z",
    fill: "#F2271C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 68C50.2091 68 52 66.2091 52 64C52 61.7909 50.2091 60 48 60C45.7909 60 44 61.7909 44 64C44 66.2091 45.7909 68 48 68Z",
    fill: "#F2271C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 28C45.8 28 44 29.8 44 32V52C44 54.2 45.8 56 48 56C50.2 56 52 54.2 52 52V32C52 29.8 50.2 28 48 28Z",
    fill: "#F2271C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8099_22736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFail);
export default __webpack_public_path__ + "static/media/verificationFail.b9dae033f526e2b35fd2642608e05bd3.svg";
export { ForwardRef as ReactComponent };